import React from 'react';
import { theme } from 'antd';
import { useTranslation } from 'react-i18next';
import EPButton from '@/components/EPButton/EPButton';
import EPModal from '@/comp/EPModal';
import { CancelButtonWrapper } from './CancelTestModal.styles';

interface CancelTestModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  loading: boolean;
  isMobile?: boolean;
}
const { useToken } = theme;
export const CancelTestModal: React.FC<CancelTestModalProps> = ({
  open,
  onCancel,
  onConfirm,
  loading,
  isMobile = false,
}) => {
  const { t } = useTranslation();
  const { token } = useToken();

  return (
    <EPModal
      open={open}
      width="1360"
      height="700"
      centered
      onCancel={onCancel}
      closable={true}
      styles={{
        body: {
          backgroundColor: token.colorBgElevated,
          width: isMobile ? '300px' : '600px',
          height: 'fit-content',
          paddingTop: '25px',
          paddingBottom: '25px',
          paddingLeft: '30px',
          paddingRight: '80px',
        },
      }}
    >
      <CancelButtonWrapper>
        <p className="cancel-modal-title">{t('cancel_validation_test')}</p>
        <p className="cancel-modal-content">{t('cancel_button_content')}</p>

        <div className="buttons-wrapper">
          <EPButton type="secondary" className="continue-test-button" onClick={onCancel}>
            {t('continue_test')}
          </EPButton>

          <EPButton className="button-space" type="primary" onClick={onConfirm} loading={loading}>
            {t('CANCEL_TEST')}
          </EPButton>
        </div>
      </CancelButtonWrapper>
    </EPModal>
  );
};
